import type { ICancellationToken } from '@cian/http-api';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IGetInfiniteSearchResultDesktopResponse200,
  type IGetInfiniteSearchResultDesktopResponse400,
  type TGetInfiniteSearchResultDesktopRequest,
  type TGetInfiniteSearchResultDesktopResponse_1,
  createGetInfiniteSearchResultDesktopModel,
  fetchGetInfiniteSearchResultDesktop,
} from '@/repositories/generated/shared/search-offers/v2/get-infinite-search-result-desktop';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
  parameters: TGetInfiniteSearchResultDesktopRequest;
};

export function fetchGetInfiniteSearchResultDesktopService(
  params: FetchServiceParams,
): Promise<TGetInfiniteSearchResultDesktopResponse_1> {
  const {
    applicationContext: { httpApi, logger },
    parameters,
    cancellationToken,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createGetInfiniteSearchResultDesktopModel(parameters),
    '@/shared/store/serverSide/search-offers/v2/get-infinite-search-result-desktop/internal/fetchService.ts',
    logger,
  );

  return fetchGetInfiniteSearchResultDesktop<
    IGetInfiniteSearchResultDesktopResponse200,
    IGetInfiniteSearchResultDesktopResponse400
  >({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
